import { Outlet, Navigate, useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import RightRail from "./RightRail";
import Footer from "./Footer";
import { Spinner, btnPrimary, btnGhost } from "./ui";
import { useAuth } from "../context/AuthContext";

export function Layout({ rail = true }) {
  return (
    <div className="min-h-screen bg-bo-bg">
      <Header />
      <div className={`mx-auto grid max-w-[1600px] gap-5 px-3 py-5 sm:px-5 lg:grid-cols-[220px_minmax(0,1fr)] ${rail ? "xl:grid-cols-[220px_minmax(0,1fr)_300px]" : ""}`}>
        <Sidebar />
        <main className="min-w-0 bo-fade-in"><Outlet /></main>
        {rail && <RightRail />}
      </div>
      <Footer />
    </div>
  );
}

function NoAccess({ user, next }) {
  const { logout } = useAuth();
  const nav = useNavigate();
  const switchAccount = async () => { await logout(); nav(`/entrar?next=${encodeURIComponent(next)}`); };
  return (
    <div className="mx-auto max-w-md py-10" data-testid="no-access-page">
      <div className="bo-card p-7 text-center">
        <h1 className="text-xl font-extrabold">Sem acesso a esta área</h1>
        <p className="mt-2 text-sm text-gray-500">Está a usar a conta <b>{user.email}</b>, que não tem permissão para aqui. Termine a sessão e entre com uma conta autorizada.</p>
        <div className="mt-5 flex flex-col gap-2">
          <button onClick={switchAccount} className={btnPrimary} data-testid="no-access-switch-btn">Trocar de conta</button>
          <button onClick={() => nav("/")} className={btnGhost} data-testid="no-access-home-btn">Voltar ao início</button>
        </div>
      </div>
    </div>
  );
}

export function RequireAuth({ roles, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Spinner />;
  if (!user) return <Navigate to={`/entrar?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (roles && !roles.includes(user.role)) return <NoAccess user={user} next={loc.pathname} />;
  return children;
}
